import { format } from 'date-fns';

/**
 * project_management#507 — the recording lists' "Analysed" column.
 *
 * "Updated" is `metadata.updatedAt`: the last HUMAN edit (comment, flags,
 * annotations). The analysis ingest never writes it, so a successful
 * reanalysis left the list looking exactly as before — which is what the
 * July 2026 "laukiu, nesulaukiu" reports were. `analysis.analysedAt` is when
 * the analysis on screen was produced; it moves on every successful
 * (re)analysis. After a failed reanalysis the backend keeps the last good
 * result (#533), so this stays at that result's time while the status column
 * says "Reanalysis failed … — showing previous result".
 */
export const ANALYSED_AT_FORMAT = 'yyy-MM-dd H:mm:ss';

export const ANALYSED_COLUMN_HINT =
  'When the analysis shown was produced — changes after every successful (re)analysis. ' +
  '"Updated" is the last manual edit.';

export function analysedAtLabel(
  analysis: { analysedAt?: number | null } | null | undefined,
): string {
  return analysis?.analysedAt ? format(analysis.analysedAt, ANALYSED_AT_FORMAT) : '';
}
